/* Flipper Kids — Collection Card Carousel v11 (SITE-WIDE)
   Added by Claude (Anthropic AI) 2026-07-11
   Carousel with sliding-window dots (max 7), bottom-positioned above size strip.
   Color-variant images trigger the theme's swatch click to update sizes. */
(function () {
  var DEMO_HANDLES = null;
  var MAX_DOTS = 7;
  var cache = {};

  function getHandle(href) {
    var m = href && href.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function sized(src, w) {
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_' + w + 'x$1$3');
  }

  function baseName(src) {
    if (!src) return '';
    var s = src.split('?')[0];
    s = s.substring(s.lastIndexOf('/') + 1);
    return s.replace(/_[0-9]+x[0-9]*(?=\.)/, '');
  }

  function buildImgColorMap(p) {
    var colorIdx = -1;
    (p.options || []).forEach(function (o, i) {
      var n = (o.name || o || '').toString();
      if (/צבע|color/i.test(n)) colorIdx = i;
    });
    if (colorIdx === -1) return null;
    var img2color = {};
    (p.variants || []).forEach(function (v) {
      if (v.featured_image && v.featured_image.src) {
        img2color[baseName(v.featured_image.src)] = v.options[colorIdx];
      }
    });
    return img2color;
  }

  function build(link, p) {
    var images = (p.images || []).slice();
    if (images.length < 2) return;
    var wrap = link.querySelector('.hover-images') || link.querySelector('.rimage-wrapper') || link;
    if (wrap.dataset.fkCarousel) return;
    wrap.dataset.fkCarousel = '1';
    wrap.classList.add('fk-car-wrap');
    var img2color = buildImgColorMap(p);
    var idx = 0;
    var syncing = false;
    var n = images.length;

    var card = link.closest('.product-block') || link.parentElement;

    var color2imgIdx = {};
    if (img2color) {
      for (var q = 0; q < n; q++) {
        var c0 = img2color[baseName(images[q])];
        if (c0 && !(c0 in color2imgIdx)) color2imgIdx[c0] = q;
      }
    }

    images.forEach(function (s) { var im = new Image(); im.src = sized(s, 600); });

    var overlay = document.createElement('img');
    overlay.className = 'fk-car-overlay';
    overlay.alt = '';
    overlay.style.display = 'none';
    wrap.appendChild(overlay);

    var dots = document.createElement('div');
    dots.className = 'fk-car-dots';
    wrap.appendChild(dots);

    function renderDots() {
      var start = 0, end = n;
      if (n > MAX_DOTS) {
        start = Math.max(0, Math.min(idx - Math.floor(MAX_DOTS / 2), n - MAX_DOTS));
        end = start + MAX_DOTS;
      }
      var html = '';
      for (var j = start; j < end; j++) {
        var cls = 'fk-dot';
        if (j === idx) cls += ' fk-dot--on';
        if (n > MAX_DOTS && ((j === start && start > 0) || (j === end - 1 && end < n))) cls += ' fk-dot--edge';
        html += '<span class="' + cls + '"></span>';
      }
      dots.innerHTML = html;
    }
    renderDots();

    function showImageOnly(i) {
      idx = (i + n) % n;
      if (idx === 0) {
        overlay.style.display = 'none';
      } else {
        overlay.src = sized(images[idx], 600);
        overlay.style.display = 'block';
      }
      renderDots();
    }

    function triggerColor(color) {
      if (!card || !color) return;
      var items = card.querySelectorAll('.product-card__variant--item.color');
      for (var k = 0; k < items.length; k++) {
        if (items[k].getAttribute('data-color') === color) {
          if (!items[k].classList.contains('selected')) {
            syncing = true;
            try { items[k].click(); } catch (e) {}
            syncing = false;
          }
          return;
        }
      }
    }

    function show(i) {
      showImageOnly(i);
      if (img2color) {
        var color = img2color[baseName(images[idx])];
        if (color) triggerColor(color);
      }
    }

    if (card) {
      card.addEventListener('click', function (e) {
        if (syncing) return;
        var sw = e.target.closest ? e.target.closest('.product-card__variant--item.color') : null;
        if (!sw || !card.contains(sw)) return;
        var color = sw.getAttribute('data-color');
        if (color in color2imgIdx) {
          showImageOnly(color2imgIdx[color]);
        } else {
          showImageOnly(0);
        }
      });
    }

    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fk-car-arrow fk-car-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'next' ? 'תמונה הבאה' : 'תמונה קודמת');
      b.innerHTML = dir === 'next' ? '&#10094;' : '&#10095;';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        show(dir === 'next' ? idx + 1 : idx - 1);
      });
      wrap.appendChild(b);
    });

    var sx = null, sy = null, swiped = false;
    link.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiped = false;
    }, { passive: true });
    link.addEventListener('touchmove', function (e) {
      if (sx === null) return;
      var dx = e.touches[0].clientX - sx;
      var dy = e.touches[0].clientY - sy;
      if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
        e.preventDefault();
      }
    }, { passive: false });
    link.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        e.preventDefault();
        show(dx > 0 ? idx + 1 : idx - 1);
        setTimeout(function () { swiped = false; }, 400);
      }
    }, { passive: false });
    link.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function scan() {
    var links = document.querySelectorAll('a.product-block__image, a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      (function (a) {
        var handle = getHandle(a.getAttribute('href') || '');
        if (!handle) return;
        if (DEMO_HANDLES && DEMO_HANDLES.indexOf(handle) === -1) return;
        if (!a.querySelector('img')) return;
        if (a.closest('.product-gallery, .product__media, [data-product-single-media-group]')) return;
        var w = a.querySelector('.hover-images') || a.querySelector('.rimage-wrapper') || a;
        if (w.dataset.fkCarousel) return;
        fetchProduct(handle).then(function (p) { if (p) build(a, p); });
      })(links[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else { scan(); }

  var t = null;
  var mo = new MutationObserver(function () {
    clearTimeout(t); t = setTimeout(scan, 300);
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();